/** https://stackoverflow.com/a/16699507/4479653 */
export const PHONE_REGEXP =
  /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
